import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createSlots as _createSlots, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7beab8c2")
const _hoisted_1 = { class: "pb-16" }
const _hoisted_2 = { class: "layout-header mb-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
_popScopeId()

import { ref } from 'vue';
// Composables
import useBreakpoints from '@/composables/useBreakpoints';
import usePoolTransfers from '@/composables/contextual/pool-transfers/usePoolTransfers';
import { useRoute } from 'vue-router';
// Components
import MyPoolBalancesCard from '@/components/cards/MyPoolBalancesCard/MyPoolBalancesCard.vue';
import MyWalletTokensCard from '@/components/cards/MyWalletTokensCard/MyWalletTokensCard.vue';
import BalAccordion from '@/components/_global/BalAccordion/BalAccordion.vue';
import Col3Layout from '@/components/layouts/Col3Layout.vue';
import usePoolTransfersGuard from '@/composables/contextual/pool-transfers/usePoolTransfersGuard';

/**
 * STATE
 */

export default _defineComponent({
  setup(__props) {

const route = useRoute();
const id = ref<string>(route.params.id as string);

/**
 * COMPOSABLES
 */
const { upToLargeBreakpoint } = useBreakpoints();
const {
  pool,
  loadingPool,
  useNativeAsset,
  transfersAllowed
} = usePoolTransfers();
usePoolTransfersGuard();

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: { name: 'pool', params: { id: id.value } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            name: "x",
            size: "lg"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(Col3Layout, {
      offsetGutters: "",
      mobileHideGutters: ""
    }, _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_router_view, {
          key: _ctx.$route.path
        }),
        (_unref(upToLargeBreakpoint))
          ? (_openBlock(), _createBlock(BalAccordion, {
              key: 0,
              class: "mt-4",
              sections: [
          {
            title: _ctx.$t('poolTransfer.myWalletTokensCard.title'),
            id: 'myWalletTokens'
          },
          {
            title: _ctx.$t('poolTransfer.myPoolBalancesCard.title'),
            id: 'myPoolBalances'
          }
        ]
            }, {
              myWalletTokens: _withCtx(() => [
                (_unref(loadingPool) || !_unref(transfersAllowed))
                  ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 0,
                      class: "h-64"
                    }))
                  : (_openBlock(), _createBlock(MyWalletTokensCard, {
                      key: 1,
                      pool: _unref(pool),
                      useNativeAsset: _unref(useNativeAsset),
                      "onUpdate:useNativeAsset": _cache[1] || (_cache[1] = ($event: any) => (_isRef(useNativeAsset) ? useNativeAsset.value = $event : null)),
                      hideHeader: "",
                      noBorder: "",
                      square: ""
                    }, null, 8, ["pool", "useNativeAsset"]))
              ]),
              myPoolBalances: _withCtx(() => [
                (_unref(loadingPool) || !_unref(transfersAllowed))
                  ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 0,
                      class: "h-64"
                    }))
                  : (_openBlock(), _createBlock(MyPoolBalancesCard, {
                      key: 1,
                      pool: _unref(pool),
                      hideHeader: "",
                      noBorder: "",
                      square: ""
                    }, null, 8, ["pool"]))
              ]),
              _: 1
            }, 8, ["sections"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (!_unref(upToLargeBreakpoint))
        ? {
            name: "gutterLeft",
            fn: _withCtx(() => [
              (_unref(loadingPool) || !_unref(transfersAllowed))
                ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                    key: 0,
                    class: "h-64"
                  }))
                : (_openBlock(), _createBlock(MyWalletTokensCard, {
                    key: 1,
                    pool: _unref(pool),
                    useNativeAsset: _unref(useNativeAsset),
                    "onUpdate:useNativeAsset": _cache[0] || (_cache[0] = ($event: any) => (_isRef(useNativeAsset) ? useNativeAsset.value = $event : null))
                  }, null, 8, ["pool", "useNativeAsset"]))
            ])
          }
        : undefined,
      (!_unref(upToLargeBreakpoint))
        ? {
            name: "gutterRight",
            fn: _withCtx(() => [
              (_unref(loadingPool) || !_unref(transfersAllowed))
                ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                    key: 0,
                    class: "h-64"
                  }))
                : (_openBlock(), _createBlock(MyPoolBalancesCard, {
                    key: 1,
                    pool: _unref(pool)
                  }, null, 8, ["pool"]))
            ])
          }
        : undefined
    ]), 1024)
  ]))
}
}

})